// src/pages/app-home.ts
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import "../components/app-shell";

@customElement("app-home")
export class AppHome extends LitElement {
  static styles = css`
    .card {
      width: min(820px, 100%);
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      background: #fff;
      padding: 18px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      box-sizing: border-box;
      font-family: var(--font-corporate);
    }

    .title {
      margin: 0 0 8px 0;
      font-size: 18px;
      font-weight: 700;
    }

    .text {
      margin: 0;
      color: rgba(0, 0, 0, 0.75);
      line-height: 1.5;
    }
  `;

  render() {
    return html`
      <app-shell .center=${true}>
        <div class="card">
          <div class="title">Startseite</div>
          <p class="text">
            Hier finden Sie den direkten Kontakt zu unserem Technik-Team.
          </p>
          <p class="text">
            Zögern Sie nicht, uns zu kontaktieren, unser Ticketsystem zu nutzen und finden Sie alle Erste-Hilfe-Tips rund um die Tankstelle.
          </p>
        </div>
      </app-shell>
    `;
  }
}
